export default __webpack_public_path__ + "static/media/Coffee-Gable-Coffee-Discovery-3.2a9c34cb.jpg";